export enum DescriptionColor {
  TextGray = 'text-gray',
  LightBlue = 'text-lightblue'
}
